/* eslint-disable */
/**
 * tokens.js — Design tokens til OS-dashboard.
 * Palet: "Fintech Authority + brand-varme" — godkendt af René 2026-06-15
 *
 * Importeres af alle os-ny komponenter.
 * Farver, spacing og status-semantik er defineret her.
 */

// Baggrundsfarver
export const BG = {
  app:     '#080c1e',
  kort:    '#0e1428',
  kortHvr: '#121830',
  sidebar: '#070b1c',
  overlay: 'rgba(4,6,20,0.80)',
};

// Kanter
export const KANT = {
  standard: 'rgba(255,255,255,0.12)',
  fin:      'rgba(255,255,255,0.07)',
  aktiv:    'rgba(63,212,199,0.35)',
};

// Tekst
// OS-11: sekundær hævet fra #6b7fa0 (4.50:1) til #8a9fc0 (6.79:1 på BG.kort)
// Opfylder WCAG AA 4.5:1 for normal tekst med komfortabel margin.
export const TEKST = {
  primær:   '#f0f4f8',
  sekundær: '#8a9fc0',
  dæmpet:   '#3a4a60',
  link:     '#3fd4c7',
};

// Statusfarver (semantiske — bruges i badges, KPI-bjælker, sparklines)
export const STATUS = {
  live:          '#22c55e',   // grøn  — data er live og frisk
  konfigureret:  '#3b82f6',   // blå   — endpoint sat op, data ikke bekræftet live
  ikkeForbundet: '#475569',   // grå   — ingen tilslutning
  opmærksomhed:  '#f59e0b',   // amber — kræver handling
  fejl:          '#ef4444',   // rød   — kritisk fejl
  ai:            '#8b5cf6',   // lilla — AI/agent-relateret
  brand:         '#2322be',   // brand-blå — KUN til baggrunde/dekorative elementer, ALDRIG til tekst
};

// Badge-konfiguration (baggrund + kant + tekst per status)
export const BADGE_FV = {
  // Integration-sprog (bruges til datakilder som Dinero, Facebook, Google)
  LIVE:             { bg: 'rgba(34,197,94,0.12)',  kant: 'rgba(34,197,94,0.30)',  txt: '#4ade80' },
  KONFIGURERET:     { bg: 'rgba(59,130,246,0.12)', kant: 'rgba(59,130,246,0.30)', txt: '#60a5fa' },
  'IKKE FORBUNDET': { bg: 'rgba(71,85,105,0.12)',  kant: 'rgba(71,85,105,0.28)',  txt: '#94a3b8' },
  OPMÆRKSOMHED:     { bg: 'rgba(245,158,11,0.12)', kant: 'rgba(245,158,11,0.30)', txt: '#fbbf24' },
  FEJL:             { bg: 'rgba(239,68,68,0.12)',  kant: 'rgba(239,68,68,0.30)',  txt: '#f87171' },
  AI:               { bg: 'rgba(139,92,246,0.12)', kant: 'rgba(139,92,246,0.30)', txt: '#a78bfa' },
  // Agent-sprog (bruges til agenter og afdelinger — ikke integration-sprog)
  AKTIV:            { bg: 'rgba(34,197,94,0.12)',  kant: 'rgba(34,197,94,0.30)',  txt: '#4ade80' },
  STANDBY:          { bg: 'rgba(71,85,105,0.12)',  kant: 'rgba(71,85,105,0.28)',  txt: '#94a3b8' },
  FEJL_AGENT:       { bg: 'rgba(239,68,68,0.12)',  kant: 'rgba(239,68,68,0.30)',  txt: '#f87171' },
};

// Kantradius
export const RADIUS = {
  kort:   14,
  knap:   8,
  pill:   20,
  badge:  6,
};

// Font
export const FONT = {
  family: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  mono:   '"SF Mono", "Fira Code", "Consolas", monospace',
};

// Spacing-system
export const SPACING = {
  kortPadding:     '20px 24px',
  kortPaddingTæt:  '16px 20px',
  gap:             16,
  sektionGap:      28,
  headerMB:        18,
};

// Typografi-trin
// OS-11: kpiLabel hævet 11→12px for bedre læsbarhed ved lille fed tekst.
// OS-11: badge hævet 9→11px — 9px er under WCAG-minimumsstørrelse for tekst.
export const TYPE = {
  kpiTal:     { fontSize: 36, fontWeight: 800, lineHeight: 1 },
  kpiLabel:   { fontSize: 12, fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase' },
  sektHeader: { fontSize: 15, fontWeight: 700, letterSpacing: 0.1 },
  tabelHoved: { fontSize: 11, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' },
  tabelCelle: { fontSize: 13, fontWeight: 400, lineHeight: 1.5 },
  badge:      { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: 'uppercase' },
  mono:       { fontFamily: '"SF Mono","Fira Code","Consolas",monospace', fontSize: 12 },
};
